/* global $ */

import { createMultiSelectDropdown } from './multi-select-dropdown';
import { debounce } from '../shared/debounce.js';

let perColumnSearchConfig = null;

function resolvePerColumnSearchConfig(config) {
    return config || perColumnSearchConfig || null;
}

export function getSelectedPerColumnSearchColumns(config) {
    config = resolvePerColumnSearchConfig(config);
    if (!config) return [];
    const prefix = config.dropdownPrefix;
    const selected = [];
    $('.' + prefix + '-checkbox:checked').each(function () {
        const value = $(this).val();
        if (value !== 'all') selected.push(value);
    });
    if ($('#' + prefix + '_all').is(':checked') || selected.length === 0) return config.columnKeys;
    return selected;
}

export function performPerColumnSearch($input, config) {
    config = resolvePerColumnSearchConfig(config);
    if (!config) return;
    $input = $input && $input.length ? $input : $(config.inputSelector);
    if (!$input || !$input.length) return;
    const searchValue = $input.val().toLowerCase();
    try { sessionStorage.setItem(config.storageKey, searchValue); } catch (error) { console.error(error); }
    if (config.gridId && document.getElementById(config.gridId)) {
        document.dispatchEvent(new CustomEvent('data-grid-refresh', { detail: { gridId: config.gridId } }));
    }
}

export function initPerColumnSearchDropdown(config) {
    config = resolvePerColumnSearchConfig(config);
    if (!config) return;
    const prefix = config.dropdownPrefix;
    if ($('#' + prefix + '_filter_dropdown').length === 0) return;

    const allCheckboxSelector = '#' + prefix + '_all';
    const itemCheckboxSelector = '.' + prefix + '-checkbox';
    const columnOptions = config.columnOptions || config.columnKeys.slice().map((k) => ({ value: k, label: k }));

    const dropdown = createMultiSelectDropdown({
        allCheckboxSelector,
        itemCheckboxSelector,
        textSelector: '#' + prefix + '_filter_text',
        options: columnOptions,
        allLabel: 'All Columns',
        allCheckboxId: prefix + '_all',
        eventNamespace: 'perColSearch_' + prefix,
        triggerSelector: '#' + prefix + '_filter_btn',
        preferredMaxHeight: 320,
    }, {
        onAllChange: () => performPerColumnSearch($(config.inputSelector), config),
        onItemChange: () => performPerColumnSearch($(config.inputSelector), config),
    });

    if ($(allCheckboxSelector).is(':checked')) {
        $(itemCheckboxSelector).filter(function () { return $(this).val() !== 'all'; }).prop('checked', true);
    }
    dropdown.updateItemClasses();
    dropdown.updateText();
}

export function initPerColumnSearch(config) {
    if (!config || !config.dropdownPrefix || !config.columnKeys) return;
    perColumnSearchConfig = config;

    const $searchField = $(config.inputSelector);
    if ($searchField.length === 0) return;

    const debouncedSearch = debounce(() => performPerColumnSearch($searchField, config), 300);
    $searchField.off('keyup.perColumnSearch').on('keyup.perColumnSearch', debouncedSearch);

    $(document).off('change.perColumnSearch', '.' + config.dropdownPrefix + '-checkbox').on('change.perColumnSearch', '.' + config.dropdownPrefix + '-checkbox', function () {
        performPerColumnSearch($(config.inputSelector), config);
    });

    initPerColumnSearchDropdown(config);
}
